module.exports = __webpack_public_path__ + "img/7378792.png";